import {LocationsApi} from "../../Api/LocationsApi";
import {TreatmentsApi} from "../../Api/TreatmentsApi";
import {DoctorsApi} from "../../Api/DoctorsApi";
import {BookingApi} from "../../Api/BookingApi";
import {doctorInitialState} from "../Helpers/initialState/doctorInitialState";
import {locationInitialState} from "../Helpers/initialState/locationInitialState";

const servicesApi = new TreatmentsApi();
const locationApi = new LocationsApi();
const doctorsApi = new DoctorsApi();
const bookingApi = new BookingApi();

export async function getRootData() {
  const [specializationsResponse, servicesResponse, serviceGroupsResponse, locationsResponse, doctorsResponse] =
    await Promise.all([
      servicesApi.getSpecializations(),
      servicesApi.getServices(),
      servicesApi.getServiceGroups(),
      locationApi.get(),
      doctorsApi.get(),
    ]);

  const allCenters = {
    ...locationInitialState,
    id: "-1",
    name: "Vis alle steder",
    supportsOnlineBooking: true,
    centers: locationsResponse
      .filter((c) => c.isLocation == false)
      .map((c) => c.id),
    isLocation: true,
    specializations: specializationsResponse.map(s => s.id)
  };
  locationsResponse.unshift(allCenters);

  const initialDoctor = {
    ...doctorInitialState,
    id: "-1",
    name: "Vis alle behandlere",
    centers: allCenters.centers,
    services: servicesResponse.map((s) => s.id),
  };

  doctorsResponse.unshift(initialDoctor);
  return {
    specializations: specializationsResponse,
    services: servicesResponse,
    serviceGroups: serviceGroupsResponse,
    centers: locationsResponse,
    doctors: doctorsResponse,
  };
}

export async function useThirdStepSubmit(request: any) {
  return await bookingApi.create(request);
}

export async function useThirdStepSubmitMetodika(request: any) {
  return await bookingApi.createMetodika(request);
}

export async function useThirdStepDropInSubmit(request: any) {
  return await bookingApi.dropIn(request);
}

export async function useThirdStepConfirm(request: any) {
  return await bookingApi.confirm(request);
}
